import mdcRipple from './mdc-ripple.vue'
export const mdcRippleComponents = {
  mdcRipple,
}